import React from 'react';
import PropTypes from 'prop-types';

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, LoadableLazy } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { useSubmitSSRScriptErrors } from '@confluence/ssr-scripts-utils/entry-points/useSubmitSSRScriptErrors.ts';

import { WATCH_BUTTON_METRIC } from '../src/perf.config.js';
import { WatchButtonPlaceholder } from '../src/WatchButtonPlaceholder.js';

export const LazyDialogWrapperLoader: LoadableType<any> = LoadableLazy<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-watch-dialog" */ '../src/WatchDialogWrapper.js'))
			.WatchDialogWrapper,
	loading: WatchButtonPlaceholder,
});
export const WatchDialogWrapperLoader: LoadableType<any> = LoadablePaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-watch-dialog" */ '../src/WatchDialogWrapper.js'))
			.WatchDialogWrapper,
	loading: WatchButtonPlaceholder,
});
export const WatchDialogWrapper: {
	(props: any): React.JSX.Element;
	propTypes: {
		contentId: PropTypes.Requireable<string>;
		defaultTab: PropTypes.Requireable<number>;
		componentLocation: PropTypes.Requireable<number>;
	};
} = (props: any): React.JSX.Element => {
	useSubmitSSRScriptErrors('page-watch-button');
	return (
		<>
			<PageSegmentLoadStart key={props.contentId} metric={WATCH_BUTTON_METRIC} />
			<WatchDialogWrapperLoader {...props} />
		</>
	);
};

WatchDialogWrapper.propTypes = {
	contentId: PropTypes.string,
	defaultTab: PropTypes.number,
	componentLocation: PropTypes.number,
};
